import { helpers } from 'vuelidate/lib/validators';
import banks from '../config/banks';

const bankAccountLength = (param) => helpers.withParams(
  { type: 'bankAccountlength', val: param },
  (bankAccountNumber) => {
    if (!bankAccountNumber) {
      return false;
    }

    const unmaskedBankAccountNumber = bankAccountNumber.replace('-', '');
    const bank = banks[param];
    if (bank !== undefined) {
      const lengths = bank.numericAccountLength;
      const validLengths = Array.isArray(lengths) ? lengths : [lengths];
      return validLengths.includes(unmaskedBankAccountNumber.length);
    }

    const isCaixaSavings = param === '1288';
    const isCaixaChecking = param === '3701';
    if (isCaixaSavings || isCaixaChecking) {
      const lengths = banks['104'].numericAccountLengthLong;
      const validLengths = Array.isArray(lengths) ? lengths : [lengths];
      return validLengths.includes(unmaskedBankAccountNumber.length);
    }

    return unmaskedBankAccountNumber.length >= 6 && unmaskedBankAccountNumber.length <= 13;
  },
);

export default bankAccountLength;
